// export const setContent = (content) => ({
//     type: 'SET_CONTENT',
//     content,
// })
export const addContent = (content) => ({
    type: 'ADD_CONTENT',
    content,
})
export const removeContent = (content) => ({
    type: 'REMOVE_CONTENT',
    content,
})
export const reset = (content) => ({
    type: 'RESET_CONTENT',
    content,
})

export const setContentSize = (id, width, height) => ({
    type: 'SET_CONTENT_SIZE',
    id,
    width,
    height
})

export const scaleUp = (id) => ({
    type: 'SCALE_UP',
    id
})
export const scaleDown = (id) => ({
    type: 'SCALE_DOWN',
    id
})
export const setScale = (id, scale) => ({
    type: 'SET_SCALE',
    id,
    scale
})


export const activate = (id) => ({
    type: 'SET_CONTENT_ACTIVE',
    id,
    active: true
})

export const deactivate = (id) => ({
    type: 'SET_CONTENT_ACTIVE',
    id,
    active: false
})

export default {
    // setContent,
    addContent,
    removeContent,
    reset,
    setContentSize,
    scaleUp,
    scaleDown,
    setScale,
    activate,
    deactivate
}